import styled from "styled-components";

export const Container = styled.section`
  margin-top: 12rem;
  display: flex;
  align-items: center;
  gap: 2rem;

  h1 {
    font-size: 7rem;
  }

  h2 {
    display: inline-block;
    font-size: 3rem;
    margin: 0rem;
    color: var(--blue);
  }

  h3 {
    margin-top: 2rem;
  }

  p {
    font-size: 1.8rem;
    letter-spacing: 0.1rem;
    font-weight: 500;
  }

  .hard-skills {
    margin-top: 1.6rem;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 3.5rem;
  }
  .hability {
    display: flex;
    flex-direction: column;
    align-items: center;
    filter: grayscale(1);
    transition: 310ms ease;
    img {
      width: 3.4rem;
    }
  }
  .hability:hover {
    filter: none;
    transform: scale(1.5);
  }

  @media (max-width: 960px) {
    display: block;
    text-align: center;
  }
  
`;
